<div class="title">
  <div class="title__title" translate>{{ title }}</div>
</div>
